import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorAppointmentRegistrationList from './components/VisitorAppointmentRegistrationList';

const { Cell } = ResponsiveGrid;

const VisitorAppointmentRegistration = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客預約及登記"
        // description="訪客列表"
        breadcrumbs={[
          {
            name: '訪客管理',
          },
          {
            name: '訪客預約及登記',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorAppointmentRegistrationList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorAppointmentRegistration;
